export default __webpack_public_path__ + "static/media/Apercu-Bold-Pro.b460d1ce.woff";